import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-511630c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "data-manage-layout" }
const _hoisted_2 = { class: "options" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_editor_toolbox = _resolveComponent("ui-editor-toolbox")!

  return (_openBlock(), _createBlock(_component_ui_editor_toolbox, {
    toolbox: $setup.showToolbox,
    "onUpdate:toolbox": _cache[0] || (_cache[0] = ($event: any) => (($setup.showToolbox) = $event)),
    disabledAnimation: "",
    class: "ttt"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.options, (option) => {
            return _createElementVNode("span", {
              class: _normalizeClass({ active: option.label === $setup.current }),
              onClick: ($event: any) => ($setup.current = option.label)
            }, _toDisplayString(option.label), 11 /* TEXT, CLASS, PROPS */, _hoisted_3)
          }), 64 /* STABLE_FRAGMENT */))
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createBlock(_resolveDynamicComponent($setup.options.find(item => item.label === $setup.current).comp)))
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["toolbox"]))
}